function showToast({ title = "", message = "", type = "info", duration = 3000 }) {
	const icons = {
		success: `
			<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" fill="#1CAD64"/>
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" stroke="#1CAD64" stroke-width="1.15385"/>
				<path d="M21.5788 11.778L13.9195 20.0128C13.6897 20.2599 13.388 20.3842 13.0864 20.3842C12.7848 20.3842 12.4831 20.2599 12.2533 20.0128L8.42378 15.8954C7.96291 15.4001 7.96291 14.5993 8.42378 14.104C8.88443 13.6085 9.62902 13.6085 10.0899 14.104L13.0864 17.3258L19.9127 9.98662C20.3733 9.49111 21.1179 9.49111 21.5788 9.98662C22.0394 10.4819 22.0394 11.2825 21.5788 11.778Z" fill="white"/>
			</svg>
		`,
		error: `
			<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" fill="#FF4545"/>
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" stroke="#FF4545" stroke-width="1.15385"/>
				<path d="M10 10L20 20M20 10L10 20" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
			</svg>

		`,
		warning: `
			<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" fill="#FFC107"/>
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" stroke="#FFC107" stroke-width="1.15385"/>
				<path d="M15 8V18" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
				<circle cx="15" cy="22" r="1.5" fill="white"/>
			</svg>

		`,
		info: `
			<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" fill="#17A2B8"/>
				<rect x="0.576923" y="0.576923" width="28.8462" height="28.8462" rx="14.4231" stroke="#17A2B8" stroke-width="1.15385"/>
				<path d="M15 10C14.3096 10 13.75 9.44036 13.75 8.75C13.75 8.05964 14.3096 7.5 15 7.5C15.6904 7.5 16.25 8.05964 16.25 8.75C16.25 9.44036 15.6904 10 15 10Z" fill="white"/>
				<path d="M15 22V13" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
			</svg>
		`
	};

	let container = document.querySelector(".toast-container");
	if (!container) {
		container = document.createElement("div");
		container.className = "toast-container";
		document.body.appendChild(container);
	}

	const toast = document.createElement("div");
	toast.className = `toast toast-${type}`;
	toast.innerHTML = `
        <div class="toast-icon">${icons[type] || "ℹ"}</div>
        <div class="toast-content">
            <p class="toast-heading">${title}</p>
            <p class="toast-message">${message}</p>
        </div>
        <div class="toast-progress"></div>
    `;

	container.appendChild(toast);

	// Auto-remove with pause on hover
	let timeout = setTimeout(() => removeToast(toast), duration);

	toast.addEventListener("mouseenter", () => clearTimeout(timeout)); // Pause on hover
	toast.addEventListener("mouseleave", () => {
		toast.classList.add("leaving"); // Speeds up progress bar
		leaveTimeout = setTimeout(() => removeToast(toast), 1000);
	});

}

function removeToast(toast) {
	toast.classList.add("hide");
	setTimeout(() => toast.remove(), 300);
}

window.showToast = showToast;
